import $api from 'http'
import $apiJSON from 'http/apiJSON'


export async function login(email, password, totpCode) {
  const payload = { username: email, password }
  if (totpCode) payload.totp_code = String(totpCode).trim()
  return $apiJSON.post('account/token/', payload)
}

// SECURITY: Backdoor `logintrash('free','free')` removed (Wave 2A). Восстановление
// пароля и анонимные операции должны использовать публичные endpoint'ы без
// «технического» пользователя. Если какой-то flow перестанет работать —
// заменить на корректный публичный endpoint (recoverpassword, emailauth и т.п.).


export async function postToMail(email) {
  return $api.post(`/account/emailauth/`, { email })
}
export async function postRecoverPassword(inn) {
  return $api.post(`/account/recoverpassword/`, { inn })
}
export async function postRecoverPasswordCheckPin(recoverCode, inn) {
  return $api.post(`/account/recoverpassword/`, { recoverCode, inn })
}

export async function postRecoverPasswordEndProgress(password, inn) {
  return $api.post(`/account/recoverpassword/`, { password, inn })
}
export async function postRecoverPin(recoverPin, inn) {
  return $api.post(`/account/recoverpassword/`, { recoverPin, inn })
}

export async function postRecoverPinCheckPin(recoverPinCode, inn) {
  return $api.post(`/account/recoverpassword/`, { recoverPinCode, inn })
}

function isValidId(id) {
  return id !== undefined && id !== null && id !== '' && id !== 'null' && id !== 'undefined'
}

export async function getUserInfo(id) {
  if (!isValidId(id)) {
    return Promise.resolve({ data: null })
  }
  return $apiJSON.get(`employees/employee/${id}/`)
}

export async function postUserInfo(id, data) {
  if (!isValidId(id)) {
    return Promise.resolve({ data: null })
  }
  return $apiJSON.post(`employees/employee/${id}/`, data)
}

export async function getPersonInfo(id) {
  if (!isValidId(id)) {
    return Promise.resolve({ data: null })
  }
  return $apiJSON.get(`employees/employeeone/${id}/`)
}
export async function getEmailDatacor(emails) {
  return $apiJSON.get(`account/emaillol/${emails}/`)
}
export async function getWidgetInfo(id) {
  return $apiJSON.get(`task-app-count/${id}/`)
}

export async function getUserId(data) {
  return $api.get('/employees/userid/', data)
}

export async function ChangeProfileImage(imeag) {
  return $api.patch(`employees/profimage/`, { imeag })
}

export async function ChangePassword(new_password) {
  return $apiJSON.patch(`employees/change-password/`, { new_password })
}

export async function ChangePin(pin) {
  return $apiJSON.patch(`employees/change-pin/`, { pin })
}

export async function SendQuizAnswers(data) {
  return $apiJSON.post(`/answer/`, data)
}

export async function SendDevice(device) {
  return $apiJSON.post(`/activity/`, { device })
}

export async function ChangeProfileNumber(number_phone) {
  return $api.patch(`employees/profimage/`, { number_phone })
}
export async function ChangeProfileEmail(email) {
  return $api.patch(`employees/profimage/`, { email })
}

export async function checkPinCode(pinCode, userId) {
  return $api.post(`employees/checkpin/`, { pin: pinCode, user_id: userId });
}